
const tamanhoCnpjSemDv = 12
const regexCnpjSemDv = /^([A-Z\d]){12}$/
const regexCnpj = /^([A-Z\d]){12}(\d){2}$/
const regexCaracteresMascaraCnpj = /[./-]/g
const regexCaracteresNaoPermitidosCnpj = /[^A-Z\d./-]/i
const valorBaseCnpj = "0".charCodeAt(0)
const pesosDvCnpj = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const cnpjZerado = "00000000000000"


/**
 * Verifica se o CNPJ alfanumerico eh valido
 * 
 * @author www.gov.br
 * @since 14/01/2025
 */
function cnpjAlfaValido(cnpj) {
  let valido = false
  if(!regexCaracteresNaoPermitidosCnpj.test(cnpj)) {
    let cnpjSemMascara = removeMascaraCnpjAlfa(cnpj)
    if((regexCnpj.test(cnpjSemMascara)) && (cnpjSemMascara !== cnpjZerado)) {
      const dvInformado = cnpjSemMascara.substring(tamanhoCnpjSemDv)
      const dvCalculado = calcularDvCnpjAlfa(cnpjSemMascara.substring(0, tamanhoCnpjSemDv))
	  valido = (dvInformado === dvCalculado)
    }
  }
  return valido
}

/**
 * Calcula o DV do CNPJ alfanumerico
 * 
 * @author www.gov.br
 * @since 14/01/2025
 */
function calcularDvCnpjAlfa(cnpj) {
  if(!regexCaracteresNaoPermitidosCnpj.test(cnpj)) {
    let cnpjSemMascara = removeMascaraCnpjAlfa(cnpj)
    if((regexCnpjSemDv.test(cnpjSemMascara)) && 
       (cnpjSemMascara !== cnpjZerado.substring(0, tamanhoCnpjSemDv))) {
      let somatorioDv1 = 0
      let somatorioDv2 = 0
      for(let i = 0; i < tamanhoCnpjSemDv; i++) {
        const asciiDigito = cnpjSemMascara.charCodeAt(i) - valorBaseCnpj
        somatorioDv1 += asciiDigito * pesosDvCnpj[i + 1]
        somatorioDv2 += asciiDigito * pesosDvCnpj[i]
      }
      const modSomaDv1 = somatorioDv1 % 11
      const dv1 = (modSomaDv1 < 2) ? 0 : (11 - modSomaDv1)
      somatorioDv2 += dv1 * pesosDvCnpj[tamanhoCnpjSemDv];
      const modSomaDv2 = somatorioDv2 % 11
      const dv2 = (modSomaDv2 < 2) ? 0 : (11 - modSomaDv2);
      return `${dv1}${dv2}`;
    }
  }
  return "@@";
}

/**
 * Remove a mascara do CNPJ alfanumerico
 * 
 * @author www.gov.br
 * @since 14/01/2025
 */
function removeMascaraCnpjAlfa(cnpj) {
  return (cnpj || '').replace(regexCaracteresMascaraCnpj, '')
}

function ValidaCPF(numCPF)
{
let i
numCPF = numCPF.replace(/\D+/g, '')
numCPF = numCPF.padStart(11, '0')

if(numCPF.length < 11)
 return false

 if(numCPF==='11111111111' || numCPF==='22222222222' || numCPF==='33333333333'|| numCPF==='44444444444' ||
    numCPF==='55555555555' || numCPF==='66666666666' || numCPF==='77777777777'|| numCPF==='88888888888' ||
    numCPF==='99999999999' || numCPF==='00000000000')
    return false

     var calculo = numCPF.substr(0,9);  
     var soma = 0;
     var cpfdigito = 0;
     var digito = "";      
    
     [...numCPF].forEach( function(c, i) {
       if(i < 9)
        soma = soma + parseInt(c) * (10 - i)
     });

     cpfdigito = 11 - soma % 11;
    
     if (cpfdigito > 9) {
       calculo = calculo + "0";
      } 
     else {
       digito = digito + cpfdigito;
       calculo = calculo + digito.charAt(0);
      }
  
     soma = 0;
  
 
     [...numCPF].forEach( function(c, i) {
       if(i < 10)
       soma = soma + parseInt(c) * (11 - i)
     });

     cpfdigito = 11 - soma%11;
  
     if (cpfdigito > 9) {
       calculo = calculo + "0";
      } 
     else {
       digito = "";
       digito = digito + cpfdigito;
       calculo = calculo + digito.charAt(0);
      }   
      return numCPF === calculo

}

/*
function gerarDigitosCNPJ(cnpj) {
   
    let i
    let digito_1 = 0;      
    let array_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2 ];

    for(i = 0; i < 12; i++)
    {
     digito_1 += array_1[i] * parseInt(cnpj.charAt(i))
    }	
   
     digito_1 = ((digito_1 % 11) < 2) ? 0 : 11 - (digito_1 % 11)
     
  
    let  digito_2 = 0;
    let array_2 = [ 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2 ];	
    for(i = 0; i < 13; i++)
    {
     digito_2 += array_2[i] * parseInt(cnpj.charAt(i))
      }
  
      digito_2 = ((digito_2 % 11) < 2) ? 0 : 11 - (digito_2 % 11)
    
    return "" + digito_1 + digito_2
    
  }
  */
  
    // Retorno: false para invalido e true para valido
  function ValidaCNPJ(cnpj) {  
    /*
    cnpj = cnpj.replace(/\D+/g, '')
    if(cnpj.length != 14)
      return false
     return gerarDigitosCNPJ(cnpj.substring(0,14)) == (cnpj.charAt(12) + cnpj.charAt(13))
    */
   
    return cnpjAlfaValido(cnpj)
  }

export default {
    ValidaCPF,
    ValidaCNPJ
}
